import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import pick from 'lodash/pick'
import { List, Map } from 'immutable'
import { bindActionCreators } from 'redux'
import { connect as connectRedux } from 'react-redux'
import { compose } from 'recompose'
import { Container, Grid } from '@mui/material'
import MuiButton from 'gui/components/common/MuiButton'
import Accordion from 'gui/components/accordion'
import ImageUpload from 'gui/components/image-upload'
import { getD6ContentType } from 'services/content/d6-content-types'
import { STORE_KEY_IMAGES } from 'services/images/store-keys'
import { deleteImage as deleteImageAction } from 'services/images/redux/actions'
import { findView, getViewRecords } from 'services/data'
import {
  getDataList as getDataListAction,
  setDataApplicationByKey as setDataApplicationByKeyAction,
} from 'services/data/redux/actions'
import { CONTENT_STORE_KEY, createContentImagesRelationshipViewOptions } from 'services/content'
import {
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_4X3_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_NO_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_NO_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_NO_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_VISUAL_INTEREST,
  ASSET_CONTENT_REFERENCE_TYPE_TOPICS_ROW,
  ASSET_CONTENT_REFERENCE_TYPE_POSTER_3X4,
  ASSET_CONTENT_REFERENCE_TYPE_POSTER_IMAGE,
  ASSET_CONTENT_REFERENCE_TYPE_PERSON_HEADSHOT_CIRCLE,
  ASSET_CONTENT_REFERENCE_TYPE_PORTRAIT,
  ASSET_CONTENT_REFERENCE_TYPE_LOGO,
  ASSET_CONTENT_REFERENCE_TYPE_TERM,
  ASSET_CONTENT_REFERENCE_TYPE_HEADSHOT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_NO_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_2X3_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_1X1_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_1X1_NO_TEXT,
} from 'services/assets/content-reference-types'

const CONTENT_IMAGES = List([
  Map({
    title: 'Keyart No Text',
    type: ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_NO_TEXT,
  }),
  Map({
    title: 'Keyart With Text',
    type: ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_WITH_TEXT,
  }),
  Map({
    title: 'Hero No Text',
    type: ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_NO_TEXT,
  }),
  Map({
    title: 'Hero With Text',
    type: ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_WITH_TEXT,
  }),
  Map({
    title: 'Poster 3x4',
    type: ASSET_CONTENT_REFERENCE_TYPE_POSTER_3X4,
  }),
  Map({
    title: 'Poster CVR',
    type: ASSET_CONTENT_REFERENCE_TYPE_POSTER_IMAGE,
  }),
  Map({
    title: 'Person Headshot Circle',
    type: ASSET_CONTENT_REFERENCE_TYPE_PERSON_HEADSHOT_CIRCLE,
  }),
  Map({
    title: 'Person Headshot',
    type: ASSET_CONTENT_REFERENCE_TYPE_HEADSHOT,
  }),
  Map({
    title: 'Portrait',
    type: ASSET_CONTENT_REFERENCE_TYPE_PORTRAIT,
  }),
  Map({
    title: 'Logo',
    type: ASSET_CONTENT_REFERENCE_TYPE_LOGO,
  }),
  Map({
    title: 'Term',
    type: ASSET_CONTENT_REFERENCE_TYPE_TERM,
  }),
  Map({
    title: 'Keyart 4K Text',
    type: ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_WITH_TEXT,
  }),
  Map({
    title: 'Keyart 4X3 Text',
    type: ASSET_CONTENT_REFERENCE_TYPE_KEYART_4X3_WITH_TEXT,
  }),
  Map({
    title: 'Keyart 4K No Text',
    type: ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_NO_TEXT,
  }),
  Map({
    title: 'Keyart 2K Text',
    type: ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_WITH_TEXT,
  }),
  Map({
    title: 'Keyart 2K No Text',
    type: ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_NO_TEXT,
  }),
  Map({
    title: 'Keyart 2X3 Text',
    type: ASSET_CONTENT_REFERENCE_TYPE_KEYART_2X3_WITH_TEXT,
  }),
  Map({
    title: '1x1 Text',
    type: ASSET_CONTENT_REFERENCE_TYPE_1X1_WITH_TEXT,
  }),
  Map({
    title: '1x1 No Text',
    type: ASSET_CONTENT_REFERENCE_TYPE_1X1_NO_TEXT,
  }),
  Map({
    title: 'Topics Row Image',
    type: ASSET_CONTENT_REFERENCE_TYPE_TOPICS_ROW,
  }),
  Map({
    title: 'Visual Interest Image',
    type: ASSET_CONTENT_REFERENCE_TYPE_VISUAL_INTEREST,
  }),
])

/**
 * Handle the on click event for image delete
 * @param {Event} e The on click event
 * @param {Object} props The prop types
 * @param {Map} props.storeKey The content store key
 * @param {Map} props.storeKeyImages The images store key
 * @param {Map} props.data The data state
 * @param {Map} props.content The content state
 * @param {typeof deleteImageAction} props.deleteImage Dispatch action to delete image
 * @param {typeof getDataListAction} props.getDataList Dispatch action to get a data list
 * @param {typeof setDataApplicationByKeyAction} props.setDataApplicationByKey
 *   Dispatch action to set data application by key
 * @param {Map} props.imageView The images view
 * @param {String} props.imageId The images id
 */
function onClickImageDelete (e, props) {
  const { storeKeyImages, deleteImage, imageId, imageView } = props
  deleteImage({
    storeKey: storeKeyImages,
    imageApplicationData: Map(),
    imageApplicationKey: 'dummy-key',
    applicationKey: 'dummy-key',
    imageView,
    imageId,
  })
}

/**
 * Handle on create image and reload content images
 * @param {Map} image The image which was created
 * @param {Object} props The prop types
 * @param {Map} props.storeKeyImages The images store key
 * @param {Map} props.content The content state
 */
function onCreateImage (image, props) {
  const { content, storeKeyImages, getDataList } = props
  getDataList({
    storeKey: storeKeyImages,
    options: createContentImagesRelationshipViewOptions(content),
  })
}

/**
 * Component to render an image column
 * @param {Object} props The prop types
 * @param {Map} props.storeKey The content store key
 * @param {Map} props.storeKeyImages The images store key
 * @param {Map} props.data The data state
 * @param {Map} props.content The content state
 * @param {typeof deleteImageAction} props.deleteImage Dispatch action to delete image
 * @param {typeof getDataListAction} props.getDataList Dispatch action to get a data list
 * @param {typeof setDataApplicationByKeyAction} props.setDataApplicationByKey
 *   Dispatch action to set data application by key
 * @param {Map} props.imageView The images view
 */
function ContentImagesImageColumn (props) {
  const { title, type, contentRelationship, images } = props
  const image = images.find((img) => img.getIn(['contentRelationship', 'type']) === type)
  return (
    <Grid item xs={12} md={6}>
      {title}
      {image && (
        <div className="content-images__image-container">
          <img className="content-images__image" src={image.get('url')} />
          <MuiButton
            variant="contained"
            className="content-images__button"
            onClick={(e) => {
              // eslint-disable-next-line no-restricted-globals
              if (confirm('This will remove the this image from the database.')) {
                onClickImageDelete(e, { ...props, imageId: image.get('id') })
              }
            }}
          >
            Delete Image
          </MuiButton>
        </div>
      )}
      {!image && (
        <ImageUpload
          workspaceId={`content-images-${type}`}
          contentRelationship={contentRelationship.set('type', type)}
          onCreateImage={(i) => onCreateImage(i, props)}
        />
      )}
    </Grid>
  )
}

/**
 * Get the component state by combining all redux state
 * @param {Object} props The props
 * @param {Map} props.storeKeyImages The images store key
 * @param {Map} props.data The redux data state
 * @param {Map} props.content The content state
 * @returns The entire component state using props and combined redux state
 */
function getState (props) {
  const { storeKeyImages, content, data } = props
  const contentRelationship = Map({
    d6Id: content.get('contentId'),
    d6ContentType: getD6ContentType(content.get('contentType')),
    language: content.get('language'),
    isSource: content.get('language') === content.get('primaryLanguage'),
  })
  const imageViewOptions = createContentImagesRelationshipViewOptions(content)
  const imageView = findView({
    data,
    storeKey: storeKeyImages,
    options: imageViewOptions,
  })
  const images =
    getViewRecords({
      data,
      storeKey: storeKeyImages,
      options: imageViewOptions,
    }) || Map()
  return {
    contentRelationship,
    imageView,
    images,
  }
}

/**
 * Component which renders content images
 * @param {Object} props The prop types
 * @param {Map} props.storeKey The content store key
 * @param {Map} props.storeKeyImages The images store key
 * @param {Map} props.data The data state
 * @param {Map} props.content The content state
 * @param {typeof deleteImageAction} props.deleteImage Dispatch action to delete image
 * @param {typeof getDataListAction} props.getDataList Dispatch action to get a data list
 * @param {typeof setDataApplicationByKeyAction} props.setDataApplicationByKey
 *   Dispatch action to set data application by key
 */
function ContentImages (props) {
  const [show, toggleShow] = useState(true)
  const { contentRelationship, images, imageView } = getState(props)
  return (
    <Container className="content-detail__section content-images" maxWidth={false}>
      <Accordion title="Images" toggleShow={() => toggleShow(!show)} show={show} />
      {show &&
        CONTENT_IMAGES.groupBy((_, i) => Math.floor(i / 2))
          .toList()
          .map((g, gi) => (
            <Grid container spacing={2} key={`content-images-row-${gi}`}>
              {g.map((v) => (
                <ContentImagesImageColumn
                  {...props}
                  key={`content-images-${v.get('type')}`}
                  title={v.get('title')}
                  type={v.get('type')}
                  contentRelationship={contentRelationship}
                  images={images}
                  imageView={imageView}
                />
              ))}
            </Grid>
          ))}
    </Container>
  )
}

ContentImages.propTypes = {
  storeKey: PropTypes.string.isRequired,
  storeKeyImages: PropTypes.string.isRequired,
  content: ImmutablePropTypes.map.isRequired,
  data: ImmutablePropTypes.map.isRequired,
  deleteImage: PropTypes.func.isRequired,
  getDataList: PropTypes.func.isRequired,
  setDataApplicationByKey: PropTypes.func.isRequired,
}

ContentImages.defaultProps = {
  storeKey: CONTENT_STORE_KEY,
  storeKeyImages: STORE_KEY_IMAGES,
}

export default compose(
  connectRedux(
    (state) => pick(state, ['data']),
    (dispatch) =>
      bindActionCreators(
        {
          deleteImage: deleteImageAction,
          getDataList: getDataListAction,
          setDataApplicationByKey: setDataApplicationByKeyAction,
        },
        dispatch,
      ),
  ),
)(ContentImages)
